<template>
  <div>
    <v-card v-if="checkPromoLoading" flat>
      <v-card-text>
        <v-progress-circular size="64" color="primary" indeterminate />
      </v-card-text>
    </v-card>
    <div v-else>
      <div v-if="!servicesUnavailable">
        <v-row>
          <v-col cols="12">
            <v-sheet>
              <v-card-text>
                <h2>{{ promo.name }}</h2>
                <p>{{ promo.description }}</p>
              </v-card-text>
            </v-sheet>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-sheet>
              <v-card-text>
                <h3>Select Service</h3>
                <p>The following services are eligible for this promotion. Please select a service.</p>
                <p>Promotion details will be confirmed on the next step.</p>
                <v-card-text>
                  <v-form>
                    <v-autocomplete
                      :loading="!promoServicesPopulated"
                      v-model="selectedService"
                      :items="eligibleServices"
                      item-text="fullName"
                      label="Select a service"
                      v-validate="'required'"
                      :error-messages="errors.collect('service')"
                      data-vv-as="Service"
                      data-vv-name="service"
                      outlined
                      return-object />
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <gg-btn color="primary" tile elevation="0" @click="nextStep">Next</gg-btn>
                  <gg-btn tile elevation="0">Cancel</gg-btn>
                </v-card-actions>
              </v-card-text>
            </v-sheet>
          </v-col>
        </v-row>
      </div>
      <v-sheet v-else>
        {{ noServiceMsg }}
      </v-sheet>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PromoUpgrade',
  data: () => ({
    selectedService: '',
    noServiceMsg: 'You have no services eligible for this promotion. Please contact us if you have any questions.',
    checkPromoLoading: true
  }),
  computed: {
    ...mapGetters(['promo', 'services', 'promoServices', 'promoServicesPopulated']),
    serviceIds () {
      return this.promoServices.map(service => service.service_id)
    },
    eligibleServices () {
      return this.services.reduce((carry, service) => {
        if (this.serviceIds.indexOf(+service.id) !== -1) {
          carry.push({
            ...service,
            fullName: `${service.name} - ${service.groupname} - ${service.domain}`,
          })
        }
        return carry
      }, [])
    },
    servicesUnavailable () {
      return this.eligibleServices.length === 0
    }
  },
  methods: {
    ...mapActions(['checkPromo', 'reportError']),
    async check () {
      try {
        this.checkPromoLoading = true
        await this.checkPromo(this.promo.id)
      } catch (err) {
        this.checkPromoLoading = false
        this.reportError(err)
      }
      if (this.eligibleServices.length === 1) {
        this.selectedService = this.eligibleServices[0]
        await this.nextStep()
      } else {
        this.checkPromoLoading = false
      }
    },
    async nextStep () {
      const valid = await this.$validator.validateAll()
      if (!valid) return
      this.$emit('service-selected', this.selectedService)
    },
  },
  mounted () {
    this.check()
  }
}
</script>
